export const TOGGLE_ACTIVE_TAB = tab => (dispatch) => {
  dispatch({ type: 'TOGGLE_ACTIVE_TAB', tab });
};

export const CLEAR_ACTIVE_TAB = tab => (dispatch) => {
  dispatch({ type: 'CLEAR_ACTIVE_TAB', tab });
};

// To do: join those two for both mobile and desktop
export const POPULATE_TAB = target => (dispatch) => {
  dispatch({ type: 'POPULATE_TAB', target });
};

export const POPULATE_TAB_DESKTOP = (target, index) => (dispatch) => {
  dispatch({ type: 'POPULATE_TAB_DESKTOP', target, index });
};

export const SHOULD_GOOGLE_MAPS_LOAD = () => (dispatch) => {
  dispatch({ type: 'SHOULD_GOOGLE_MAPS_LOAD' });
};
